import * as React from 'react';
import { gql } from '@apollo/client';
import {
  useGetCategoriesLazyQuery,
  useGetQueueMetadataLazyQuery,
  useGetSocialProfilesLazyQuery,
  useUpdatePauseSettingsMutation,
  useUpdatePauseSettingsPerProfileCategoryMutation
} from '../../../models/graphql';
import { PauseController, PauseSettingsControllerProps } from './Pause.controller';

gql`
  mutation UpdatePauseSettings($workspaceId: ID!, $input: UpdateWorkspaceSettingsInput!) {
    updateWorkspaceSettings(workspaceId: $workspaceId, input: $input) {
      id
      queuesPaused
      autoImportsPaused
    }
  }

  mutation updatePauseSettingsPerProfileCategory($workspaceId: ID!, $input: [QueueMetaInput!]!) {
    bulkUpdateQueueMeta(workspaceId: $workspaceId, input: $input) {
      socialProfile {
        id # Only grab the id here, no other fields, otherwise it gets very expensive on the backend.
      }
      category {
        id # Only grab the id here, no other fields, otherwise it gets very expensive on the backend.
      }
      paused
    }
  }

  query GetQueueMetadata($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      queueMeta {
        socialProfile {
          id # Only grab the id here, no other fields, otherwise it gets very expensive on the backend.
        }
        category {
          id # Only grab the id here, no other fields, otherwise it gets very expensive on the backend.
        }
        paused
      }
    }
  }
`;

export const PauseApollo = (): JSX.Element => {
  const [getCategoriesQuery, categoriesResults] = useGetCategoriesLazyQuery();
  const [getSocialProfilesQuery, socialProfilesResults] = useGetSocialProfilesLazyQuery();
  const [getQueueMetadataQuery, queueMetadataResults] = useGetQueueMetadataLazyQuery();
  const [updateWorkspacePauseSettings] = useUpdatePauseSettingsMutation();
  const [updatePauseSettingsPerProfileCategory] = useUpdatePauseSettingsPerProfileCategoryMutation();

  const controllerProps: PauseSettingsControllerProps = {
    updateWorkspacePauseSettings,
    getCategoriesQuery,
    getSocialProfilesQuery,
    getQueueMetadataQuery,
    categoriesResults,
    socialProfilesResults,
    queueMetadataResults,
    updatePauseSettingsPerProfileCategory
  };
  return <PauseController {...controllerProps} />;
};
